<template>
  <div>
    <slot
      name="button"
      v-bind:openModal="openModal"
      v-bind:closeModal="closeModal">
    </slot>
    <div
      class="fixed z-20 inset-0"
      :class="{
        'px-6': size === 'full'
      }"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      v-if="open">
      <div
        class="flex justify-center min-h-screen text-center p-6 sm:p-0"
        :class="{
          'items-center': anchor === 'center',
          'items-end': anchor === 'bottom',
          'items-start': anchor === 'top'
        }">
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75"
          aria-hidden="true"
          @click="clickOutsideModal">
        </div>
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true">
          &#8203;
        </span>
        <div
          class="inline-block bg-white rounded-lg text-left shadow-xl transform transition-all sm:align-bottom mb-6 h-[calc(100vh-6.5rem)] w-full p-3"
          :class="{
            'sm:my-8 sm:align-middle sm:h-fit': size === 'sm',
            'sm:my-8 sm:align-middle': size === 'md',
            'sm:align-bottom mb-6 h-[calc(100vh-6.5rem)]': size === 'full',
            'overflow-hidden': !overflow,
            'sm:max-w-xl': width === '1',
            'sm:max-w-2xl': width === '2',
            'sm:max-w-3xl': width === '3',
            'sm:max-w-4xl': width === '4',
            'sm:max-w-5xl': width === '5',
            'sm:max-w-6xl': width === '6',
          }">
          <div class="flex flex-col h-full">
            <div class="text-xl tracking-wide font-bold uppercase flex-shrink-0">
              <slot name="title"></slot>
            </div>
            <div class="flex-grow overflow-y-auto">
              <slot
                name="content"
                v-bind:openModal="openModal"
                v-bind:closeModal="closeModal"
              ></slot>
            </div>
            <div class="mt-2 flex-shrink-0 flex justify-end gap-4">
              <button
                v-if="showClose" 
                type="button"
                class="rounded-md font-medium text-gray-900 bg-gray-100 px-3 py-2 hover:bg-gray-200 transition-colors shadow-sm"
                @click="() => closeModal()">
                Close
              </button>
              <slot
                name="footer"
                v-bind:openModal="openModal"
                v-bind:closeModal="closeModal">
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isBoolean } from 'lodash'

export default {
  props: {
    overflow: {
      default: false,
      type: Boolean
    },
    size: {
      default: 'md',
      type: String
    },
    width: {
      default: '1',
      type: String
    },
    anchor: {
      default: 'bottom',
      type: String
    },
    onClose: {
      default: function () {},
      type: Function
    },
    onSuccess: {
      default: function () {},
      type: Function
    },
    showClose: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      open: false,
      closeCallback: this.onClose,
      successCallback: this.onSuccess,

      preventLoseFocus: false,
    }
  },
  methods: {
    setOpen(value) {
      this.preventLoseFocus = true
      this.open = value
    },
    openModal() {
      this.preventLoseFocus = true
      this.open = true
    },
    async closeModal(success = false) {
      if (isBoolean(success) && success) {
        await this.successCallback()
      }
      await this.closeCallback()
      this.open = false
    },
    setCloseCallback(callback) {
      this.closeCallback = callback
    },
    setSuccessCallback(callback) {
      this.successCallback = callback
    },
    clickOutsideModal() {
      if (this.open) {
        this.closeModal()
      }
    },
    onLoseFocus() {
      // This would be the callback for the "v-outside-click" directive
      // Turns out "v-outside-click" is unnecessary since the Modal puts up
      //   a full screen background, so the outside-click directive would never
      //   actually trigger
      if (this.preventLoseFocus) {
        this.preventLoseFocus = false
        return
      }
      if (this.open) {
        this.closeModal()
      }
    },
  }
}
</script>
